import { render } from "./TSMDefectsPage.vue?vue&type=template&id=88532c7a"
import script from "./TSMDefectsPage.vue?vue&type=script&lang=js"
export * from "./TSMDefectsPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__